import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/results',
    component: () => import(/* webpackChunkName: "results" */ '../views/Results.vue')
  },
  {
    path: '/days',
    component: () => import(/* webpackChunkName: "sessions" */ '../views/Days.vue')
  },
  {
    path: '/days/:day',
    component: () => import(/* webpackChunkName: "sessions" */ '../views/Day.vue')
  },
  {
    path: '/days/:day/:session',
    component: () => import(/* webpackChunkName: "session" */ '../views/Session.vue')
  },
  {
    path: '/days/:day/:session/:presentation',
    component: () => import(/* webpackChunkName: "presentation" */ '../views/Presentation.vue')
  },
  {
    path: '/days/:day/:session/:presentation/:person',
    component: () => import(/* webpackChunkName: "person" */ '../views/Person.vue')
  },
  {
    path: '/error',
    component: () => import(/* webpackChunkName: "error" */ '../views/Error.vue')
  },
  {
    path: '*',
    redirect: '/days',
  },
]

const router = new VueRouter({
  routes
})

router.beforeEach(async (to, from, next) => {
  const token = sessionStorage.getItem('token');
  if (!token && to.path !== '/login') {
    store.dispatch('removeToken');
  } else {
    if (to.path.match(/\/days/) && !store.state.days.length) {
      await store.dispatch('getDays');
    }
    if (to.path.match(/\/days\/[0-9]+/) && !store.state.sessions.length) {
      await store.dispatch('getSessions', { id: to.params.day });
    }
    if (to.path.match(/\/days\/[0-9]+\/[0-9]+/) && !store.state.presentations.length) {
      await store.dispatch('getPresentations', { id: to.params.session });
    }
    next();
  }
})

export default router
